import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Check, Clock, Users } from 'lucide-react';

const API = `${window.__BACKEND_URL__}/api`;

// Job detail → Overview: hours per assigned worker so multi-worker jobs bill and pay correctly (Sep 2026).
export default function CrewHoursPanel({ jobId, refreshKey }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    if (!jobId) return undefined;
    let cancelled = false;
    axios.get(`${API}/jobs/${jobId}/crew-time`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then((r) => { if (!cancelled) setData(r.data); })
      .catch((e) => { if (!cancelled) setErr(e.response?.data?.detail || 'Could not load crew hours'); });
    return () => { cancelled = true; };
  }, [jobId, refreshKey]);
  if (err) return <p className="text-xs text-slate-500" data-testid="crew-hours-error">{err}</p>;
  if (!data) return null;
  const rows = data.workers || [];
  return (
    <div className="rounded-lg border border-[#2D3748] bg-[#1A2433] p-3" data-testid="crew-hours-panel">
      <div className="flex items-center justify-between gap-2 mb-2">
        <p className="text-sm font-semibold text-white flex items-center gap-1.5"><Users className="w-4 h-4 text-[#00C896]" /> Hours by worker</p>
        <p className="text-xs text-slate-400" data-testid="crew-hours-total">
          {data.total_session_hours.toFixed(2)}h on job{data.total_payroll_hours ? ` · ${data.total_payroll_hours.toFixed(2)}h payroll` : ''}{data.billable_estimate != null ? ` · ≈ $${data.billable_estimate.toFixed(2)} billable` : ''}
        </p>
      </div>
      {rows.length === 0 ? <p className="text-xs text-slate-500">No workers or time yet.</p> : (
        <ul className="space-y-1.5">
          {rows.map((w) => (
            <li key={w.user_id} className="text-xs" data-testid={`crew-hours-row-${w.user_id}`}>
              <div className="flex items-center gap-2">
                <span className="text-white font-medium truncate">{w.name}</span>
                {w.assigned ? (w.acknowledged ? <Check className="w-3 h-3 text-[#00C896]" title="Got it" /> : <Clock className="w-3 h-3 text-slate-500" title="Not acknowledged yet" />) : <span className="text-[10px] text-slate-500">(not assigned)</span>}
                {w.open_session && <span className="text-[10px] text-[#FFA000]">working now</span>}
                <span className="ml-auto text-slate-300 tabular-nums">{w.session_hours.toFixed(2)}h</span>
                <span className="text-slate-500 w-9 text-right tabular-nums">{w.share_pct}%</span>
              </div>
              <div className="h-1 rounded bg-slate-700 mt-1"><div className="h-1 rounded bg-[#00C896]" style={{ width: `${w.share_pct}%` }} /></div>
              <p className="text-[10px] text-slate-500 mt-0.5">{w.sessions} session{w.sessions === 1 ? '' : 's'}{w.payroll_hours ? ` · ${w.payroll_hours.toFixed(2)}h payroll` : ''}{w.last_worked ? ` · last ${new Date(w.last_worked).toLocaleDateString()}` : ''}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
